import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Card from 'honeydew/Card';
import { trackEvent } from 'utils/analyticsUtils';
import { getPercentOffOriginalPrice, getProductOriginalPrice } from 'utils/productUtils';

function AssortmentProductCard({ aisle, item }) {
    const percentOff = getPercentOffOriginalPrice(item);
    const originalPrice = getProductOriginalPrice(item);
    const isMango = window.location.pathname.includes('mango');

    return (
        <Link
            to={`/${item.slug}/p?redirect=true`}
            target={isMango ? '_top' : '_self'}
            className="min-h-[333px]"
            onClick={() => {
                localStorage.setItem('prevPath', isMango ? 'home' : 'join');

                trackEvent('grocery preview product card clicked', {
                    location: isMango ? 'home page' : 'lead capture page',
                    aisle,
                    product_name: item?.name,
                });
            }}
        >
            <div className="min-h-[260px] min-w-[150px] p-5">
                <Card extendedStyles={{ wrapper: 'h-[160px] w-[160px]', padding: 'p-5' }}>
                    <img
                        src={item.photoMed}
                        alt={item.name}
                        className="mx-auto min-h-[150px] min-w-[150px]"
                        height="150"
                        width="150"
                    />
                </Card>
                <div className="flex gap-10 pt-10">
                    {originalPrice > item?.price && (
                        <p className="text-body-sm mt-[2px] line-through">${originalPrice.toFixed(2)}</p>
                    )}
                    {percentOff > 5 && (
                        <p className="text-body-sm text-brand-primary font-grotesk-bold">{percentOff}% off</p>
                    )}
                </div>
                {item?.price && <p className="text-body-md font-grotesk-bold">${item.price.toFixed(2)}</p>}
                {item?.name && <p className="text-body-sm line-clamp-2">{item.name}</p>}
                {item?.sourcingReason && (
                    <p className="text-body-sm mt-5 line-clamp-2 w-fit rounded-md bg-off-white px-5">
                        {item.sourcingReason}
                    </p>
                )}
            </div>
        </Link>
    );
}

AssortmentProductCard.propTypes = {
    aisle: PropTypes.string.isRequired,
    item: PropTypes.shape({
        msrp: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        photoMed: PropTypes.string.isRequired,
        portion: PropTypes.number.isRequired,
        price: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        sourcingReason: PropTypes.string.isRequired,
    }).isRequired,
};

export default AssortmentProductCard;
